import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions} from 'redux-router5';
import {Button, Segment} from 'semantic-ui-react';
import {datadogLogs} from '@datadog/browser-logs';

import {Loading} from 'Common/Structure';
import {estimateActions, invoiceActions, paymentActions} from 'actions';

import InfoPanel from '../InfoPanel';
import {isPaymentsApp} from 'helpers';
import {urls} from 'helpers/constants';
import {useFlags} from 'helpers/customHooks';

import {isTokenGuest} from '../../../../../api/request';

const WePayCallback = props => {
  const [loading, setLoading] = useState(true);
  const [invoice, setInvoice] = useState(null);
  const [estimate, setEstimate] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    loadPage();
  }, []);

  useEffect(
    () => {
      if (hasError) {
        throw new Error('Invoice ID or Estimate ID not found.');
      }
    },
    [hasError],
  );

  const loadPage = async () => {
    const {
      checkout_id,
      customerId,
      estimateId,
      k,
      invoiceId,
      portalId,
      type,
    } = props.router.route.params;

    if (!checkout_id) {
      const isGuestPayment = await isTokenGuest();
      datadogLogs.logger.error('WePay callback - unknown checkout id', {
        ...props.router.route.params,
        referrer: document.referrer,
        isPaymentsApp: isPaymentsApp(),
        isGuestPayment,
      });
    }

    await props.savePayment({
      checkoutId: checkout_id,
      customerId,
      estimateId,
      k,
      invoiceId,
      portalId,
      type,
    });

    if (estimateId) {
      const estimate = await props.loadEstimate(estimateId);
      setEstimate(estimate);
    } else if (invoiceId) {
      const invoice = await props.loadInvoice(invoiceId);
      setInvoice(invoice);
    } else {
      setHasError(true);
    }

    setLoading(false);
  };

  const {reactInvoiceEstimateLists} = useFlags();
  const navigateAway = () => {
    if (reactInvoiceEstimateLists) {
      props.navigateTo('invoices');
    } else {
      window.location = urls.Invoices;
    }
  };

  return (
    <Segment>
      {loading ? (
        <Loading inline />
      ) : (
        <>
          <InfoPanel estimate={estimate} invoice={invoice} />

          {!isPaymentsApp() && (
            <div style={{marginTop: 25, textAlign: 'right'}}>
              <Button onClick={navigateAway} primary type="button">
                Close
              </Button>
            </div>
          )}
        </>
      )}
    </Segment>
  );
};

WePayCallback.propTypes = {
  router: PropTypes.object.isRequired,

  // functions
  loadEstimate: PropTypes.func.isRequired,
  loadInvoice: PropTypes.func.isRequired,
  savePayment: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  router: state.router,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadEstimate: estimateActions.loadEstimate,
      loadInvoice: invoiceActions.loadInvoice,
      savePayment: paymentActions.savePayment,
      navigateTo: actions.navigateTo,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WePayCallback);



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/WePayCallback/index.js